import React from "react";

const salonVideos = [
  {
    src: "/videos/tiktok1.mov",
    title: "Bombshell Curls U-Part Install"
  },
  {
    src: "/videos/tiktok2.mov",
    title: "Seamless Wig Install"
  },
  {
    src: "/videos/tiktok3.mov",
    title: "Ash Blonde Raw Hair Transformation"
  },
  {
    src: "/videos/tiktok4.mov",
    title: "Silky Straight Install"
  },
  {
    src: "/videos/tiktok5.mov",
    title: "Bodywave Glam Styling"
  },
  {
    src: "/videos/tiktok6.mov",
    title: "Natural Curly Finish"
  }
];

const SalonVideos = () => {
  return (
    <section
      id="salon-videos"
      className="py-4"
      style={{
        textAlign: "center",
        margin: "2rem auto 1.2rem auto",
        padding: "1.2rem 0.7rem",
        background: "#fffdfa",
        borderRadius: 14,
        boxShadow: "0 2px 9px #cbb99118, 0 1px 4px #ebc47b12",
        maxWidth: 1000
      }}
    >
      <h2
        className="mb-2 fw-bold"
        style={{
          fontSize: "1.15rem",
          letterSpacing: ".02em",
          color: "#ad8b3a",
          fontFamily: "Playfair Display, serif"
        }}
      >
        Salon Video Highlights
      </h2>
      <p
        style={{
          margin: "0 0 0.6rem 0",
          color: "#6b6454",
          fontSize: ".9rem",
          maxWidth: 520,
          marginInline: "auto",
          lineHeight: 1.4
        }}
      >
        Short clips showing real installs, colour work and styling at Zoteya Beauty.
      </p>

      {/* Same grid pattern as HairShowcaseSection */}
      <div
        className="row g-2 justify-content-center"
        style={{ rowGap: "0.7rem", columnGap: "0.95rem" }}
      >
        {salonVideos.map(({ src, title }, idx) => (
          <div
            key={idx}
            className="col-6 col-md-4 col-lg-3 d-flex flex-column align-items-center"
            style={{ minWidth: 135, maxWidth: 185, margin: "0 auto", padding: 0 }}
          >
            <div
              className="w-100"
              style={{
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 7px #e3d3a619",
                padding: "0.45rem",
                overflow: "hidden"
              }}
            >
              <video
                src={src}
                controls
                playsInline
                muted
                style={{
                  width: "100%",
                  height: 190, // adjust slightly if you want less vertical space
                  borderRadius: 6,
                  objectFit: "cover",
                  backgroundColor: "#000"
                }}
              />
              <div
                style={{
                  fontSize: "0.85em",
                  fontWeight: 600,
                  color: "#83612b",
                  textAlign: "center",
                  fontFamily: "Inter, sans-serif",
                  marginTop: 4,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                {title}
              </div>
            </div>
          </div>
        ))}
      </div>

      <a
        href="https://www.instagram.com/zoteya_beauty"
        target="_blank"
        rel="noreferrer"
        className="btn fw-bold rounded-pill mt-3"
        style={{
          padding: "0.45rem 1.4rem",
          background: "linear-gradient(90deg, #c4a15a 0%, #d4c4a8 100%)",
          color: "#fff",
          border: "none",
          fontSize: ".9rem",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          fontFamily: "Playfair Display, serif",
          boxShadow: "0 2px 6px #cab37222",
          textDecoration: "none"
        }}
      >
        View more on Instagram
      </a>

      <style>{`
        @media (max-width: 576px) {
          #salon-videos {
            margin: 1.6rem auto 1rem auto;
            padding: 1rem 0.55rem;
          }
          #salon-videos video {
            height: 175px; /* slightly shorter on very small screens */
          }
        }
      `}</style>
    </section>
  );
};

export default SalonVideos;
